import { render, staticRenderFns } from "./PointsCalculation.vue?vue&type=template&id=586d341c&scoped=true"
import script from "./PointsCalculation.vue?vue&type=script&lang=js"
export * from "./PointsCalculation.vue?vue&type=script&lang=js"
import style0 from "./PointsCalculation.vue?vue&type=style&index=0&id=586d341c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d341c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586d341c')) {
      api.createRecord('586d341c', component.options)
    } else {
      api.reload('586d341c', component.options)
    }
    module.hot.accept("./PointsCalculation.vue?vue&type=template&id=586d341c&scoped=true", function () {
      api.rerender('586d341c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PointsCalculation.vue"
export default component.exports